import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { stringify } from 'qs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { config } from '../../../../config';
import { Invoice } from '../invoices';
import { Note } from '../notes';
import { Client } from './client.model';
import { Contact } from '../contact.model';
import { User } from '../users';

interface ClientResponse {
  data: Client;
}

@Injectable()
export class ClientService {
  constructor(private http: HttpClient) { }

  // @TODO In the observable description, add all different objects | FIX INTERFACE
  get(terms?: object, page?: number) {
    return this.http
      .get<any>(`${config.apiLocation}/v1/clients?${stringify({ terms, page })}`)
      .map(res => res);
  }

  getById(id: string): Observable<Client> {
    return this.http
      .get<ClientResponse>(`${config.apiLocation}/v1/clients/${id}`)
      .map(res => res.data);
  }

  customers(clientId: string) {
    return this.http.get<{ data: Contact[] }>(`${config.apiLocation}/v1/clients/${clientId}/customers`)
      .map(res => res.data);
  }

  update(client: RecursivePartial<Client>): Observable<Client> {
    return this.http
      .patch<ClientResponse>(`${config.apiLocation}/v1/clients/${client.id}`, client)
      .map(res => res.data);
  }

  // @TODO: This should potentially be moved to the auth module later down the track
  verifyAccount(clientID: string, verificationCode: string) {
    return this.http.post<{ data: any }>(`${config.apiLocation}/auth/two-factor/clients/${clientID}`, {
      'code': verificationCode
    });
  }

  // @TODO: This should potentially be moved to the auth module later down the track
  resendVerification(clientID: string): Observable<any> {
    return this.http.post<{ data: any }>(`${config.apiLocation}/auth/two-factor/clients/${clientID}/resend`, {});
  }

  createInvoice(client: Client, invoice: Invoice) {
    return this.http
      .post<{ data: any }>(`${config.apiLocation}/v1/clients/${client.id}/invoices`, invoice)
      .map(res => res.data);
  }

  createNote(client: Client, note: Note) {
    return this.http
      .post<{ data: any }>(`${config.apiLocation}/v1/clients/${client.id}/notes`, note)
      .map(res => res.data);
  }

  delete(clientId: string) {
    return this.http.delete<void>(`${config.apiLocation}/v1/clients/${clientId}`, {});
  }

  makeOwner(client: Client, user: User): Observable<ClientResponse> {
    return this.http.post<ClientResponse>(`${config.apiLocation}/v1/clients/${client.id}/owner`, {
      user_id: user.id,
    });
  }

  checkReview(client: Client) {
    return this.http.get(`${config.apiLocation}/v1/clients/${client.id}/reviewed`)
    .toPromise();
  }

  postReview(client: Client, review) {
    return this.http.post(`${config.apiLocation}/v1/debts/${client.id}/review`, {
      "rating": review.rating,
      "review": review.review
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/clients/client.service.ts